// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___2luFQ","tooltip-text":"styles__tooltip-text___3_pnL","icon":"styles__icon___9JcgE"};